export const SITE_URL = "https://axiohire.com";
export const PORTAL_ORIGIN = "https://portal.axiohire.com";
export const SUPPORT_EMAIL = "business@axiohire.com";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

export const PRIVACY_PATH = "/privacy";
export const TERMS_PATH = "/terms";
export const RECRUITER_AGREEMENT_PATH = "/recruiter-agreement";

export const PRIVACY_URL = `${SITE_URL}${PRIVACY_PATH}`;
export const TERMS_URL = `${SITE_URL}${TERMS_PATH}`;
export const RECRUITER_AGREEMENT_URL = `${SITE_URL}${RECRUITER_AGREEMENT_PATH}`;

export const AUTH_PATHS = {
  login: "/login",
  join: "/join",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
} as const;

export const APPLY_PATH = "/apply";
export const ADMIN_PATH = "/admin";
